<script setup lang="ts">
import type { Deal } from '~/types/api'

defineProps<{ deal: Deal }>()
</script>

<template>
  <article class="deal-card">
    <NuxtLink :to="`/deal/${deal.id}`" class="deal-card__link">
      <div class="deal-card__media">
        <ProductImage :src="deal.product.image_url" :alt="deal.product.name" />
        <CountdownTimer class="deal-card__timer" :ends-at="deal.ends_at" size="sm" />
      </div>
      <div class="deal-card__body">
        <h3 class="deal-card__name">{{ deal.product.name }}</h3>
        <p class="deal-card__prices">
          <span class="price">{{ formatMoney(deal.price, deal.currency) }}</span>
          <span class="badge-discount">{{ formatPct(deal.discount_pct) }}</span>
        </p>
        <p class="rrp text-sm">ARP {{ formatMoney(deal.rrp, deal.currency) }}</p>
        <ParticipantsBar
          class="deal-card__progress"
          :participants="deal.participants"
          :next-drop-at="deal.next_drop_at"
          show-label
          compact
        />
      </div>
    </NuxtLink>
    <FollowButton class="deal-card__follow" :deal="deal" />
  </article>
</template>

<style scoped>
.deal-card {
  position: relative;
  min-width: 0;
}

.deal-card__link {
  display: block;
}

.deal-card__media {
  position: relative;
  aspect-ratio: 1 / 0.95;
  background: var(--white);
  border-radius: var(--radius-sm);
  overflow: hidden;
}

.deal-card__timer {
  position: absolute;
  top: 8px;
  left: 8px;
}

.deal-card__follow {
  position: absolute;
  top: 4px;
  right: 4px;
}

.deal-card__body {
  padding: 12px 0 0;
}

.deal-card__name {
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.deal-card__prices {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  font-size: 14px;
}

.deal-card__progress {
  margin-top: 12px;
}

.deal-card__link:hover .deal-card__name {
  color: var(--brand-700);
}
</style>
